import React from 'react';
import { ListItem, ListItemText } from '@material-ui/core';
import { devToolLog } from 'app/actions';
import { storage } from 'app/util/storage';

export class DevCache extends React.Component<any, any> {
  handleClick(type: string) {
    switch (type) {
      case 'session':
        storage.session.clear();
        break;
      case 'local':
        storage.local.clear();
        break;
      case 'all':
        storage.session.clear();
        storage.local.clear();
        window.location.reload();
        break;
    }
    devToolLog(`${type} storage cleared`);
  }

  render() {
    return (
      <React.Fragment>
        <ListItem button onClick={() => this.handleClick('session')}>
          <ListItemText primary="Clear Session Storage"/>
        </ListItem>
        <ListItem button onClick={() => this.handleClick('local')}>
          <ListItemText primary="Clear Local Storage" />
        </ListItem>
        <ListItem button onClick={() => this.handleClick('all')}>
          <ListItemText primary="Clear All and Reset" />
        </ListItem>
      </React.Fragment>
    );
  }
}
